document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(".hero-banner-item");
  const bullets = document.querySelectorAll(".hero-bullet");
  let current = 0;
  const intervalTime = 5000;
  let interval;

  function showSlide(index) {
    banners.forEach((banner, i) => {
      banner.classList.toggle("active", i === index);
      bullets[i]?.classList.toggle("active", i === index);
    });
    current = index;
  }

  function nextSlide() {
    const next = (current + 1) % banners.length;
    showSlide(next);
  }

  function startAutoSlide() {
    stopAutoSlide();
    interval = setInterval(nextSlide, intervalTime);
  }

  function stopAutoSlide() {
    clearInterval(interval);
  }

  // Clique nos bullets
  bullets.forEach((bullet, index) => {
    bullet.addEventListener("click", (e) => {
      e.preventDefault();
      showSlide(index);
      startAutoSlide();
    });
  });

  // Inicia o auto slide
  if (banners.length > 1) {
    startAutoSlide();
  }

  // ── Header transparente → sólido ao scroll ──────────────────────────
  const body = document.querySelector('body');
  if (body) {
    const SCROLL_THRESHOLD = 100;
    const onScroll = () => {
      body.classList.toggle('scrolled', window.scrollY > SCROLL_THRESHOLD);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // aplica na carga caso já haja scroll
  }
});
